import { TableOperadora } from "./Components/table/TableOperadoras";

export const PageOperadoras = () => {
  return <TableOperadora />;
};
